import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Collapse, Stack, Typography } from '@mui/material'
import { ReactNode, useState } from 'react'
import COLORS from '../../../styles/colors'

export type LiveCallMonitorSectionProps = {
  title: string
  description: string
  toggleLabel: string
  children: ReactNode
}

const LiveCallMonitorSection = ({
  title,
  description,
  toggleLabel,
  children,
}: LiveCallMonitorSectionProps) => {
  const [open, setOpen] = useState(false)

  return (
    <Stack mt="16px">
      <Typography component="h3" variant="inter_h4" fontWeight={600}>
        {title}
      </Typography>
      <Typography variant="inter_bodyText" color={COLORS.grey}>
        {description}
      </Typography>

      <Stack
        direction="row"
        alignItems="center"
        spacing="4px"
        mt="4px"
        onClick={() => setOpen((prev) => !prev)}
        role="button"
        aria-expanded={open}
        sx={{ cursor: 'pointer', width: 'fit-content' }}
      >
        <Typography variant="inter_bodyText" color={COLORS.burnedOrange}>
          {toggleLabel}
        </Typography>
        <ExpandMoreIcon
          fontSize="small"
          sx={{
            color: COLORS.burnedOrange,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.15s ease',
          }}
        />
      </Stack>

      <Collapse in={open}>
        <Stack spacing="6px" mt="8px" pl="4px">
          {children}
        </Stack>
      </Collapse>
    </Stack>
  )
}

export default LiveCallMonitorSection
